const NAMESPACE = 'TEST_DATA';

const ADD_TEST_PARAMS = `${NAMESPACE}/ADD_TEST_PARAMS`;
const SET_OVERRIDES = `${NAMESPACE}/SET_OVERRIDES`;
const SET_PARAMS = `${NAMESPACE}/SET_PARAMS`;
const SET_VISITOR_ID = `${NAMESPACE}/SET_VISITOR_ID`;
const SET_CACHED_PARAMS = `${NAMESPACE}/SET_CACHED_PARAMS`;

export {
    ADD_TEST_PARAMS,
    SET_CACHED_PARAMS,
    SET_OVERRIDES,
    SET_PARAMS,
    SET_VISITOR_ID,
};

export default NAMESPACE;
